module.exports = __webpack_public_path__ + "static/media/ban-khar-reporting.9cc09d8e.svg";